import { action, makeObservable, observable } from "mobx";

import { DEFAULT_RESPONSE_LIST } from "../constants";
import {
  AddBetshopJackpotData,
  AddGameJackpotData,
  AddMegaJackpotData,
  EditJackpotData,
  JackpotByIdResponse,
  GetJackpotsRequest,
  JackpotDetailRequest,
  JackpotDetailsResponse,
  JackpotsResponse
} from "../models";
import { HttpResponse, jackpotController } from "../api";
import { RootStore } from "./index";

export class JackpotsStore {

  private rootStore: RootStore;

  jackpots = new HttpResponse<JackpotsResponse>(DEFAULT_RESPONSE_LIST);

  jackpotById = new HttpResponse<Partial<JackpotByIdResponse>>({});

  jackpotDetails = new HttpResponse<JackpotDetailsResponse>(DEFAULT_RESPONSE_LIST);

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      jackpots: observable,
      jackpotById: observable,
      jackpotDetails: observable,
      setJackpots: action.bound,
      setJackpotById: action.bound,
      seJackpotDetails: action.bound,
    });
  };

  public setJackpots(value: HttpResponse<JackpotsResponse>): void {
    this.jackpots = value;
  }

  public setJackpotById(value: HttpResponse<Partial<JackpotByIdResponse>>): void {
    this.jackpotById = value;
  }

  public seJackpotDetails(value: HttpResponse<JackpotDetailsResponse>): void {
    this.jackpotDetails = value;
  }

  public async getJackpots(params: GetJackpotsRequest): Promise<void> {
    this.setJackpots(this.jackpots.fetching());
    const data = await jackpotController.getJackpots(params);
    this.setJackpots(this.jackpots.fetched(data));
  }

  public async getJackpotById(id: number, type: number): Promise<void> {
    this.setJackpotById(this.jackpotById.fetching());
    const data = await jackpotController.getJackpotById(id, type);
    this.setJackpotById(this.jackpotById.fetched(data));
  }

  public async getJackpotDetails(params: JackpotDetailRequest): Promise<void> {
    this.seJackpotDetails(this.jackpotDetails.fetching());
    const data = await jackpotController.getJackpotDetails(params);
    this.seJackpotDetails(this.jackpotDetails.fetched(data));
  }

  public resetJackpotDetails() {
    this.seJackpotDetails(this.jackpotDetails.fetched(DEFAULT_RESPONSE_LIST));
  }

  public async addMegaJackpot(data: AddMegaJackpotData): Promise<void> {
    return await jackpotController.addMegaJackpot(data);
  }

  public async addBetshopJackpot(data: AddBetshopJackpotData): Promise<void> {
    return await jackpotController.addBetshopJackpot(data);
  }

  public async addGamesJackpot(data: AddGameJackpotData): Promise<void> {
    return await jackpotController.addGameJackpot(data);
  }

  public async editMegaJackpot(data: EditJackpotData): Promise<void> {
    return await jackpotController.editMegaJackpot(data);
  }

  public async editBetshopJackpot(data: EditJackpotData): Promise<void> {
    return await jackpotController.editBetshopJackpot(data);
  }

  public async editGamesJackpot(data: EditJackpotData): Promise<void> {
    return await jackpotController.editGameJackpot(data);
  }

  public async resetJackpotById(): Promise<void> {
    return this.setJackpotById(this.jackpotById.fetched({}));
  }

}
